import { Td, Tr } from '@chakra-ui/react';
import NoData from './NoData';
import { jsx as _jsx } from "react/jsx-runtime";

var EmptyTableRow = function EmptyTableRow(_ref) {
  var columnsLength = _ref.columnsLength;
  return /*#__PURE__*/_jsx(Tr, {
    _hover: {
      bgColor: 'transparent'
    },
    e2eid: "common_EmptyTableRow_Tr",
    children: /*#__PURE__*/_jsx(Td, {
      colSpan: columnsLength,
      e2eid: "common_EmptyTableRow_Td",
      children: /*#__PURE__*/_jsx(NoData, {
        e2eid: "common_EmptyTableRow_NoData"
      })
    })
  });
};

export default EmptyTableRow;